export default __webpack_public_path__ + "static/media/2.6194ca4e.svg";